import { useState } from "react";
import { Check, Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtDate, ageDays } from "@/lib/constants";
import { SECTIONS, AGE } from "@/components/admin/reportConfig";
import { ReportItemForm } from "@/components/admin/ReportItemForm";
import { ConfirmAction } from "@/components/admin/ConfirmAction";

const PRIMARY = {
  controllo: { label: "Controllata", title: "Segnare come controllata?", desc: "La voce sparirà dalla dashboard e dal PDF." },
  todo: { label: "Completata", title: "Segnare come completata?", desc: "Diventerà una funzionalità con la data di oggi." },
};

const IconBtn = ({ label, children, testId, ...p }) => (
  <Button variant="ghost" size="icon" className="h-10 w-10 shrink-0 rounded-full" aria-label={label} data-testid={testId} {...p}>{children}</Button>
);

export const ReportItemCard = ({ item, areas, onUpdate, onDelete, onPrimary }) => {
  const [edit, setEdit] = useState(false);
  const cfg = SECTIONS[item.type];
  const tid = `report-item-${item.item_id}`;
  const age = item.type === "feature" ? AGE.find((a) => ageDays(item.date) < a.max) : null;
  const primary = PRIMARY[item.type];

  if (edit)
    return <ReportItemForm type={item.type} initial={item} areas={areas} testId={`${tid}-edit-form`} onCancel={() => setEdit(false)}
      onSubmit={async (v) => { const ok = await onUpdate(item.item_id, v); if (ok) setEdit(false); return ok; }} />;

  return (
    <article className={`rounded-2xl border ${cfg.border} ${cfg.bg} p-4`} data-testid={tid}>
      <div className="flex items-start gap-2">
        <div className="min-w-0 flex-1">
          {item.title && <h4 className={`font-semibold ${age ? age.cls : cfg.text}`} data-testid={`${tid}-title`}>{age && <span className={`mr-2 inline-block h-2 w-2 rounded-full ${age.dot}`} />}{item.title}</h4>}
          <p className="mt-0.5 flex flex-wrap gap-x-3 text-xs text-[#75867E]">
            {item.type === "controllo" && <span data-testid={`${tid}-date`}>Implementata il {fmtDate(item.date)}</span>}
            {item.type === "feature" && <span className="font-mono">{fmtDate(item.date)}</span>}
            {item.area && item.type !== "feature" && <span>{item.area}</span>}
            {item.type === "note" && <span>{fmtDate(item.created_at)}</span>}
          </p>
          {item.description && <p className="mt-2 whitespace-pre-wrap text-sm text-[#495850]">{item.description}</p>}
          {item.type === "open_task" && item.missing && (
            <p className="mt-3 rounded-xl border border-[#FED7AA] bg-white px-3 py-2 text-sm" data-testid={`${tid}-missing`}>
              <span className="font-semibold text-[#C2410C]">Cosa manca: </span>{item.missing}
            </p>
          )}
        </div>
        <div className="flex shrink-0">
          <IconBtn label="Modifica" onClick={() => setEdit(true)} testId={`${tid}-edit-btn`}><Pencil className="h-4 w-4" /></IconBtn>
          <ConfirmAction title="Eliminare questa voce?" description="La voce sparirà ma resterà registrata, così non verrà ricreata." confirmLabel="Elimina"
            onConfirm={() => onDelete(item.item_id)} testId={`${tid}-delete`}
            trigger={<IconBtn label="Elimina" testId={`${tid}-delete-btn`}><Trash2 className="h-4 w-4 text-[#C62828]" /></IconBtn>} />
        </div>
      </div>
      {primary && (
        <ConfirmAction title={primary.title} description={primary.desc} confirmLabel={primary.label} onConfirm={() => onPrimary(item)} testId={`${tid}-primary`}
          trigger={<Button className={`mt-3 h-11 w-full rounded-full text-white sm:w-auto ${cfg.btn}`} data-testid={`${tid}-primary-btn`}><Check className="mr-2 h-4 w-4" />{primary.label}</Button>} />
      )}
    </article>
  );
};
